import type { DepartureTimeRange } from "../state/filters";
import type ItemJS from "itemsjs";

export interface LegCardItem {
  id: string;
  departure_time: DepartureTimeRange[];
  price: number;
  vehicle_type: string;
  operator_ids: string[];
  profile_ids: number[];
  is_direct_only: boolean;
  has_e_ticket: boolean;
  is_award_winner: boolean;
  // origin: number;
  // destination: number;
  classes: string[];
  origin_poi: string[];
  destination_poi: string[];
}

export const result_filter_options = {
  aggregations: {
    departure_time: {
      title: "Departure time",
      conjunction: false,
      chosen_filters_on_top: false,
      sort: "term"
    },
    vehicle_type: {
      title: "Vehicle type",
      conjunction: false,
      chosen_filters_on_top: false
    },
    operator_ids: {
      title: "Operator",
      conjunction: false,
      chosen_filters_on_top: false,
      size: 100
    },
    profile_ids: {
      title: "Profile",
      conjunction: false,
      chosen_filters_on_top: false,
      size: 100
    },
    has_e_ticket: {
      title: "E-ticket only",
      conjunction: false,
      chosen_filters_on_top: false
    },
    is_direct_only: {
      title: "Direct only",
      conjunction: false,
      chosen_filters_on_top: false
    },
    is_award_winner: {
      title: "Is an award-winner",
      conjunction: false,
      chosen_filters_on_top: false
    },
    // origin: {
    //   title: "Origin",
    //   conjunction: false,
    //   chosen_filters_on_top: false,
    //   size: 100
    // },
    // destination: {
    //   title: "Destination",
    //   conjunction: false,
    //   chosen_filters_on_top: false,
    //   size: 100
    // },
    classes: {
      title: "Classes",
      conjunction: false,
      chosen_filters_on_top: false
    },
    origin_poi: {
      title: "Origin POI",
      conjunction: false,
      chosen_filters_on_top: false
    },
    destination_poi: {
      title: "Destination POI",
      conjunction: false,
      chosen_filters_on_top: false
    }
  },
  searchableFields: [
    "departure_time",
    "vehicle_type",
    "operator_id",
    "is_direct_only",
    "has_e_ticket",
    // "origin",
    // "destination",
    "is_award_winner",
    "class",
    "origin_poi",
    "destination_poi"
  ]
} as ItemJS.Configuration<
  Partial<LegCardItem>,
  string,
  keyof Partial<LegCardItem> & string
>;
